import React from 'react';

import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

import './about.styles.scss';

export default function About() {
  return (
    <div className='about-container'>
      <MarkdownToJsx
        path={`${process.env.PUBLIC_URL}/markdown/about.md`}
      />
      <div>
        <a href='https://www.climatehubs.usda.gov/sites/default/files/FCI_508.pdf' target='_blank' rel='noreferrer'>
          <img src={`${process.env.PUBLIC_URL}/assets/FCI_CoverPage.png`} alt='Copy of Forest Climate Indicators publication cover page' />
        </a>
      </div>
    </div>
  );
}